import React, { useEffect, useState } from 'react';
import { MainWrapper } from '../main-wrapper';
import { IComponentProps } from '../../../model/studio';
import getFormatMessage from '../../../locales/get-format-message';
import { BillingContentComponent } from './billing-content';
import { getCompanyInfo } from '../../../api';
import { IAPICompanyFullInfo } from '../../../model/api-modules';
import { IRootState } from '../../../store/reducers';
import { useSelector } from 'react-redux';
import { renderRoutes, RouteConfig } from 'react-router-config';
import { PermissionCheck } from '../../component/permission-check';
import { RbacRoleObjectKey } from '../../../model';

export interface IProps {
  readonly route?: RouteConfig;
}

export const BillingRouter = (props: IProps) => {
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );
  const [companyInfo, setCompanyInfo] = useState<IAPICompanyFullInfo | null>();

  const renderComponent = (props: IComponentProps) => {
    return (
      <PermissionCheck
        contentType="page"
        permissionKey={RbacRoleObjectKey.FeeCenterView}
      >
        <BillingContentComponent
          {...props}
          onReload={async () => {
            props.onReload();
            await queryCompanyInfo();
            return true;
          }}
          companyInfo={companyInfo}
        />
      </PermissionCheck>
    );
  };

  useEffect(() => {
    queryCompanyInfo();
  }, [selectStudio]);

  const queryCompanyInfo = async () => {
    if (!selectStudio) {
      return;
    }
    const companyRes = await getCompanyInfo(selectStudio.studioID);
    setCompanyInfo(companyRes);
  };

  if (location.pathname.includes('order-result')) {
    return renderRoutes(props.route?.routes);
  }

  return (
    <MainWrapper
      className="billing-main-wrapper"
      title={getFormatMessage('billing')}
      renderComponent={renderComponent}
    />
  );
};
